import React, { FC } from 'react';

import { ContentLoadError, PageWrapper } from '../../components';

export const Error404: FC = () => (
  <PageWrapper>
    <ContentLoadError onRefreshClicked={() => window.location.reload()} />
  </PageWrapper>
);
